import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

interface AiButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** link: szövegszerű gomb (pl. az „Új blokk” mellé); solid: kitöltött gomb. */
  variant?: 'link' | 'outline' | 'solid';
  loading?: boolean;
  loadingText?: string;
}

/**
 * Az AI funkciók közös gombja: mindenhol ugyanaz az ikon és szín, hogy a
 * felhasználó első ránézésre lássa, melyik művelet használ AI-t.
 */
const AiButton: React.FC<AiButtonProps> = ({
  variant = 'outline',
  loading = false,
  loadingText = 'Dolgozom…',
  children,
  className = '',
  disabled,
  ...rest
}) => {
  const base = 'inline-flex items-center gap-1.5 text-sm font-medium disabled:opacity-50';
  const styles = {
    link: 'text-violet-700 hover:underline',
    outline: 'rounded-md border border-violet-200 bg-violet-50 px-3 py-2 text-violet-700 hover:bg-violet-100',
    solid: 'rounded-md bg-violet-600 px-4 py-2 text-white hover:bg-violet-700',
  }[variant];

  return (
    <button type="button" disabled={disabled || loading} className={`${base} ${styles} ${className}`} {...rest}>
      <SparklesIcon className={`h-4 w-4 shrink-0 ${loading ? 'animate-pulse' : ''}`} />
      {loading ? loadingText : children}
    </button>
  );
};

export default AiButton;
